import { useStorageObjectVersions } from "../../../../../../app/state/storageObjectSlice/hook/use-storage-object-versions";
import { ObjectRefContainer } from "../../../../../../common/ObjectRefContainer";
import { VersioningServiceManager } from "../../../../../../common/VersioningServiceManager";
import { AssistantValue } from "../../../../../../services/api/instances/assistantsApi/types";
import { StorageObjectVersion } from "../../../../../../services/api/instances/storageApi/types/object_types";
import { SaveVersionModal } from "../../../../../../common/VersioningServiceManager/VersioningBlockModals/SaveVersionModal";
import { RestoreVersionModal } from "../../../../../../common/VersioningServiceManager/VersioningBlockModals/RestoreVersionsModal";
import { setAssistantValue } from "../../../../redux/slice";
import { useStorageSelectors } from "../../../../../../app/state/storageObjectSlice/hook/use-storage-selectors";
import { useAppModals } from "../../../../../../app/state/modalSlice/hook/use-app-modals";
import styles from "./styles.module.css";

export const HeaderSettingsBlock = () => {
  const {
    versions,
    selectedVersion,
    createObjectVersion,
    updateObjectVersion,
    restoreObjectVersion,
    refreshVersion,
    deleteObjectVersion,
  } = useStorageObjectVersions("assistants");
  const { selectedObject } = useStorageSelectors("assistants");
  const { handleCloseModal, handleOpenModal } = useAppModals();

  return (
    <>
      <div className={styles["top-info-wrapper"]}>
        <div>
          <VersioningServiceManager
            service={"assistants"}
            versions={versions ? versions[selectedObject?.id as string] : []}
            selectedVersion={
              selectedVersion as StorageObjectVersion<AssistantValue>
            }
            onEditName={updateObjectVersion}
            onRefreshVersion={() =>
              refreshVersion(selectedVersion?.version_id as string)
            }
            onOpenSaveVersionModal={() =>
              handleOpenModal("save_version_modal", null)
            }
            onOpenRestoreVersionModal={() =>
              handleOpenModal("restore_version_modal", null)
            }
            onDeleteVersion={deleteObjectVersion}
            isSaveButtonDisabled={false}
          />
        </div>
        <ObjectRefContainer refValue={selectedObject?.ref as string} />
      </div>
      <SaveVersionModal
        selectedVersion={
          selectedVersion as StorageObjectVersion<AssistantValue>
        }
        createVersion={createObjectVersion}
        closeModal={handleCloseModal}
      />
      <RestoreVersionModal
        versions={versions ? versions[selectedObject?.id as string] : []}
        closeModal={handleCloseModal}
        onOk={(id) => restoreObjectVersion(id, setAssistantValue)}
      />
    </>
  );
};
